export const LOW_CREDIT_SCORE_PATH = '/credit-score';
export const TOO_FAR_OUT_PATH = '/too-far';
export const CASH_OUT_PATH = '/cash-out';
export const TOO_SOON_PATH = '/too-soon';
export const CONSULT_PATH = '/consult';
export const NEW_CONSTRUCTION_PATH = '/new-construction';
// For use in heavy-traffic scenarios
export const CAPACITY_PATH = '/at-capcity';
export const NON_PITCH = '/non-pitch';
export const TRADELINE_ISSUE_PATH = '/tradeline-issue';

/**
 * sessionStorage key for stored consult path
 */
export const CONSULT_CONSTANT = 'CONSULT_PATH';



// WEBPACK FOOTER //
// ./src/modules/consult-paths.js